import Icon from '@/atoms/Icon/Icon';
import styled, {css, keyframes} from 'styled-components';
import {StyledIconProps} from './typings';
import colors from '@/theme/constants/colors';

export const StyledIcon = styled(Icon)``;

export const StyledActiveIcon = styled(Icon)<StyledIconProps>`
  color: ${colors.red100};
  display: inline-block;
  transition: all 0.2s ease-in;
  ${(props) =>
    props.$loading &&
    css`
      animation: ${heartbeat} 1s ease-in;
      animation-iteration-count: infinite;
    `}
`;

const heartbeat = keyframes`
	0% {opacity: 0.9; transform: scale(1.0)}
  50% {opacity: 0.7; transform: scale(0.9)}
  100% {opacity: 0.9; transform: scale(1.0)}
`;
